<template>
  <div class="component-test-page">
    <h1>Element-UI主题注入验证页面</h1>
    <p>本页面用于验证所有Element-UI组件的样式是否符合A公司设计规范</p>

    <!-- 按钮测试 -->
    <section class="test-section">
      <h2>按钮 (Button)</h2>
      <div class="test-group">
        <el-button>默认按钮</el-button>
        <el-button type="primary">主要按钮</el-button>
        <el-button type="success">成功按钮</el-button>
        <el-button type="warning">警告按钮</el-button>
        <el-button type="danger">危险按钮</el-button>
        <el-button type="info">信息按钮</el-button>
        <el-button disabled>禁用按钮</el-button>
      </div>
      <div class="test-group">
        <el-button size="medium">中等按钮</el-button>
        <el-button size="small">小按钮</el-button>
        <el-button size="mini">迷你按钮</el-button>
      </div>
      <div class="test-group">
        <el-button class="icon-button" icon="el-icon-setting"></el-button>
        <el-button type="text">文本按钮</el-button>
      </div>
    </section>

    <!-- 输入组件测试 -->
    <section class="test-section">
      <h2>输入组件 (Input)</h2>
      <div class="test-group">
        <el-input v-model="inputValue" placeholder="请输入内容" />
        <el-input v-model="inputValue" placeholder="禁用状态" disabled />
      </div>
      <div class="test-group">
        <el-select v-model="selectValue" placeholder="请选择">
          <el-option label="选项1" value="option1" />
          <el-option label="选项2" value="option2" />
          <el-option label="选项3" value="option3" />
        </el-select>
        <el-date-picker
          v-model="dateValue"
          type="date"
          placeholder="选择日期"
        />
        <el-date-picker
          v-model="dateRangeValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
    </section>

    <!-- 表格测试 -->
    <section class="test-section">
      <h2>表格 (Table)</h2>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @row-click="handleRowClick"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="name" label="姓名" width="120" />
        <el-table-column prop="age" label="年龄" width="100" />
        <el-table-column prop="address" label="地址" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'">
              {{ scope.row.status === 'active' ? '激活' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 表单测试 -->
    <section class="test-section">
      <h2>表单 (Form)</h2>
      <el-form :model="formData" label-width="120px">
        <el-form-item label="用户名">
          <el-input v-model="formData.username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="formData.password" type="password" />
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="formData.gender" placeholder="请选择">
            <el-option label="男" value="male" />
            <el-option label="女" value="female" />
          </el-select>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker
            v-model="formData.birthday"
            type="date"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary">提交</el-button>
          <el-button>重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <!-- 标签测试 -->
    <section class="test-section">
      <h2>标签 (Tag)</h2>
      <div class="test-group">
        <el-tag>默认标签</el-tag>
        <el-tag type="success">成功标签</el-tag>
        <el-tag type="warning">警告标签</el-tag>
        <el-tag type="danger">危险标签</el-tag>
        <el-tag type="info">信息标签</el-tag>
        <el-tag size="small">小标签</el-tag>
        <el-tag size="mini">迷你标签</el-tag>
      </div>
    </section>

    <!-- 分页测试 -->
    <section class="test-section">
      <h2>分页 (Pagination)</h2>
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[20, 30, 50]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </section>

    <!-- 下拉菜单测试 -->
    <section class="test-section">
      <h2>下拉菜单 (Dropdown)</h2>
      <el-dropdown @command="handleCommand">
        <el-button type="primary">
          更多操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">选项1</el-dropdown-item>
          <el-dropdown-item command="b">选项2</el-dropdown-item>
          <el-dropdown-item command="c">选项3</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </section>

    <!-- 卡片测试 -->
    <section class="test-section">
      <h2>卡片 (Card)</h2>
      <el-card class="box-card">
        <div slot="header">
          <span>卡片标题</span>
        </div>
        <div>卡片内容</div>
      </el-card>
    </section>

    <!-- 对话框测试 -->
    <section class="test-section">
      <h2>对话框 (Dialog)</h2>
      <el-button type="primary" @click="dialogVisible = true">打开对话框</el-button>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="500px"
      >
        <span>这是一个对话框</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ComponentTest',
  data() {
    return {
      inputValue: '',
      selectValue: '',
      dateValue: '',
      dateRangeValue: '',
      formData: {
        username: '',
        password: '',
        gender: '',
        birthday: ''
      },
      tableData: [
        { name: '张三', age: 25, address: '北京市朝阳区', status: 'active' },
        { name: '李四', age: 30, address: '上海市浦东新区', status: 'active' },
        { name: '王五', age: 28, address: '广州市天河区', status: 'inactive' },
        { name: '赵六', age: 35, address: '深圳市南山区', status: 'active' },
        { name: '钱七', age: 22, address: '杭州市西湖区', status: 'inactive' }
      ],
      currentPage: 1,
      pageSize: 20,
      total: 100,
      dialogVisible: false
    }
  },
  methods: {
    handleRowClick(row) {
      console.log('行点击', row)
    },
    handleEdit(row) {
      console.log('编辑', row)
    },
    handleDelete(row) {
      console.log('删除', row)
    },
    handleSizeChange(val) {
      this.pageSize = val
      console.log('每页条数', val)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      console.log('当前页', val)
    },
    handleCommand(command) {
      console.log('命令', command)
    }
  }
}
</script>

<style scoped>
.component-test-page {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.component-test-page h1 {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--text-primary, #262626);
}

.component-test-page > p {
  font-size: 14px;
  color: var(--text-secondary, #8c8c8c);
  margin-bottom: 32px;
}

.test-section {
  margin-bottom: 48px;
  padding: 24px;
  background: white;
  border: 1px solid var(--border, #d9d9d9);
  border-radius: 3px;
}

.test-section h2 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  color: var(--text-primary, #262626);
}

.test-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.test-group:last-child {
  margin-bottom: 0;
}

.box-card {
  width: 400px;
}
</style>


